<template>
  <b-form @submit.prevent="submit">
    <page-header :title="divisa.nombre || 'Crear divisa'" subtitle="Divisas" back-to="/divisas" />
    <b-form-group label="Nombre">
      <b-form-input required type="text" v-model="divisa.nombre" placeholder="Nombre de la divisa" />
    </b-form-group>
    <b-form-group label="Abreviatura">
      <b-form-input
        v-model="divisa.abreviatura"
        required
        type="text"
        maxlength="4"
        placeholder="Abreviatura de la divisa"
      />
    </b-form-group>
    <b-form-group label="Símbolo">
      <b-form-input v-model="divisa.simbolo" required type="text" maxlength="4" placeholder="Símbolo de la divisa" />
    </b-form-group>
    <b-form-group label="Paises">
      <combo-multiple :value="paisesSeleccionados" :options="paises" @input="setPaisesSeleccionados" />
    </b-form-group>
    <b-row>
      <b-col>
        <boton-eliminar text="Eliminar divisa" @ok="eliminarDivisa" :disabled="!divisa.id">
          ¿Desea eliminar esta divisa?
        </boton-eliminar>
      </b-col>
      <b-col class="text-right">
        <botonera-edicion url-cancelar="/divisas">
          <b-button type="button" variant="dark" :disabled="!divisa.id" @click="editarTasas">
            Tasas de conversión
          </b-button>
        </botonera-edicion>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { useDivisaStore } from "@/stores/DivisaStore";
export default {
  computed: {
    ...mapState(useDivisaStore, ["divisa", "paises", "paisesSeleccionados"]),
  },
  methods: {
    ...mapActions(useDivisaStore, ["cargar", "guardar", "eliminar", "setPaisesSeleccionados"]),
    editarTasas() {
      this.$router.push("/divisas/editar-tasas/" + this.divisa.id + "?from=editar");
    },
    async submit() {
      await this.guardar();
      await this.$router.push("/divisas");
      this.$messages.success("Divisa guardada correctamente");
    },
    async eliminarDivisa() {
      if (this.divisa.id) {
        await this.eliminar();
        await this.$router.push("/divisas");
        this.$messages.info("Divisa eliminada correctamente");
      }
    },
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.cargar(this.$route.params.id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
